import React, { Component, Fragment } from "react";
import { withRouter } from "react-router";
import { withTranslation } from 'react-i18next';
class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.state = { term: "" };
        this.onInputChange = this.onInputChange.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this);
        this.keyPress = this.keyPress.bind(this);
    }
    render() {
        if (this.props.isSearchFormVisible !== true)
            return <Fragment />
        const { t } = this.props;

        return (
            <form className="site-search" method="get">
                <input
                    type="text"
                    value={this.state.term}
                    onChange={this.onInputChange}
                    onKeyDown={this.keyPress}
                    name="site_search"
                    placeholder={t("TypeToSearch")}
                    autoFocus 
                />
                <div className="search-tools">
                    <span className="clear-search" onClick={this.onClearSearch}>{t("Clear")}</span>
                    <span className="close-search" onClick={() => this.props.onCloseClick(false)}>
                        <i className="icon-cross" />
                    </span>
                </div>
            </form>
        );
    }

    keyPress(e) {
        if (e.keyCode == 13) {
            //console.log('value', e.target.value);
            let path = `${this.props.settings.baseUrl}search/${e.target.value}${this.props.location.search}`;
            this.props.history.push(path);
            e.preventDefault();
        }
        
    }

    onInputChange(event) {
        // console.log(event.target.value);
        this.setState({ term: event.target.value });
    }

    onClearSearch(event) {
 
        this.setState({ term: "" });
    }
}

export default withTranslation()(withRouter(SearchBar));
 
